import React, {Component} from 'react';
import { connect } from 'react-redux';
import {
  searchInputChanged,
  setShowSearchResults,
  navIndexChanged,
  setPointerInsideNavBox,
  itemSelected
} from './../state/search-box-actions';
import { loadNode } from './../../root/state/root-actions';
import SearchBox from './search-box';

function mapDispatchToProps(dispatch) {
  return {
    onSearchResultSelected: node => dispatch(loadNode(node)),
    onSearchChanged: n => dispatch(searchInputChanged(n)),
    onSetPointerInsideNavBox: bInside => dispatch(setPointerInsideNavBox(bInside)),
    onSetShowSearchResults: bShow => dispatch(setShowSearchResults(bShow)),
    onNavIndexChanged: nIndex => dispatch(navIndexChanged(nIndex)),
    onItemSelected: nIndex => dispatch(itemSelected(nIndex))
  };
}

function mapStateToProps(state) {
  return {
    searchResults:  state.searchBoxReducer.searchResults,
    searchWord: state.searchBoxReducer.searchWord ? state.searchBoxReducer.searchWord : '',
    isShowSearchResults: state.searchBoxReducer.bShowSearchResults,
    nSelectedNavIndex: state.searchBoxReducer.nNavIndex,
    isPointerInsideNavBox: state.searchBoxReducer.bPointerInsideNavBox,
    isDataLoading: state.searchBoxReducer.bDataIsLoading,
    isMobilePhone: state.initialStateReducer.isMobilePhone
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchBox);



/** WEBPACK FOOTER **
 ** app/components/search-box/view/search-box-container.js
 **/